import {
  homeTranslations,
  servicesTranslations,
  serviceCategoriesTranslations,
  termsTranslations,
  privacyTranslations,
  blogTranslations,
  communityTranslations,
  contactTranslations,
  eventsTranslations,
  aboutTranslations
} from './en/index'

export const enTranslations = {
  ...homeTranslations,
  ...servicesTranslations,
  ...serviceCategoriesTranslations,
  ...termsTranslations,
  ...privacyTranslations,
  ...blogTranslations,
  ...communityTranslations,
  ...contactTranslations,
  ...eventsTranslations,
  ...aboutTranslations
}
